import { executeStarknetTransaction } from '../..'
import type { Swapper } from '../../types'

export const avnuSwapper: Swapper = {
  executeStarknetTransaction,
}
